import { Link  } from 'react-router-dom';

  export default function ReadMoreButton(props){
    return(
        <div className='mb-4 mt-4'>
            <Link className='inline-block px-6 py-2.5 bg-amber-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-amber-700 hover:shadow-lg focus:bg-amber-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-amber-800 active:shadow-lg transition duration-150 ease-in-out' to={'/documentales/' + props.url}>Seguir Leyendo</Link>
        </div>
    );
  }
  